import React, { Component } from 'react';
import DelegatePage from './delegates-html';
class Delegate extends Component {
    constructor(props) {
        super(props)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }
    render() {
        return (
            <div>
                <DelegatePage
                />
            </div>
        )
    }
}
export default Delegate;